<div [ngClass]="{'pe-text':true,'pe-no-margin':item.data.fullWidth}"
     [ngStyle]="{maxWidth:layoutSetting.maxWidth + 'px'}" >
  <app-sub-component-container [layoutSetting]="layoutSetting" [item]="item">
    <!--<div [ngClass]="{'pe-text-container':true,'pe-text-pointer':EditText}" [froalaView]="item.data.description"  (click)="openWindowText()"></div>-->
     <!-- <angular-editor [(ngModel)]="htmlContent" [config]="config"></angular-editor>-->
    <div  [innerHTML]="item.data.description"  (click)="openWindowText()"></div>
  </app-sub-component-container>
</div>

